// "Ask Sage about this example" — opens Sage pinned to exactly one worked
// example, video problem or video, with a ready question in the composer (QA:
// "a hint on worked example 3" got "paste it", since Sage couldn't tell which
// example was meant). The reference travels as ids; the server loads the text
// (src/lib/tutor/material-context.ts).
//
// Renders nothing unless Sage can open here (signed in, not on a hidden route):
// lesson and video pages are public, and a button that does nothing is worse
// than none.

'use client'

import { useSyncExternalStore } from 'react'
import { Sparkles } from 'lucide-react'
import {
  askSage,
  canAskSage,
  onAskSageAvailability,
  type AskSageRequest,
} from '@/lib/tutor/on-screen-material'

export default function AskSageButton({
  request,
  children = 'Ask Sage about this example',
}: {
  request: AskSageRequest
  children?: string
}) {
  const available = useSyncExternalStore(onAskSageAvailability, canAskSage, () => false)
  if (!available) return null
  return (
    <button
      type="button"
      onClick={() => askSage(request)}
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-brand-ink transition-colors hover:bg-brand/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
    >
      <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
      {children}
    </button>
  )
}
